var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBodymaxipositive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 540,
    height: 600,
    preserveAspectRatio: "xMidYMax",
    viewBox: "0 0 540 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "body_maxi_positive_svg__c",
    d: "M10.501 111.906c0-35.108-7.15-88.387-7.15-88.387C1.826 11.04 10.783 1.218 23.344 1.582l299.748 8.682c12.566.364 21.243 10.75 19.501 23.192 0 0-6.658 40.368-6.658 73.988 0 41.138 9.91 123.413 9.91 123.413H.591s9.91-79.3 9.91-118.95z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "body_maxi_positive_svg__e",
    d: "M.517 81.885l1-53.782C1.517 12.86 13.881.501 29.14.501c15.256 0 27.623 12.367 27.623 27.61l-1 52.774"
  }), /*#__PURE__*/React.createElement("path", {
    id: "body_maxi_positive_svg__g",
    d: "M0 131.894C0 59.051 59.056 0 131.895 0 204.739 0 263.79 59.044 263.79 131.894v63.565c0 72.844-58.883 136.317-131.517 141.771l-.378.028-.378-.028C58.882 331.775 0 268.31 0 195.46v-63.566z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "body_maxi_positive_svg__i",
    d: "M147.67 132.11c70.667-.135 141.033 37.115 141.033 37.115s27.419-140.683-141.938-169c-176.197 24.802-144.14 169-144.14 169s73.776-36.978 145.046-37.115z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "body_maxi_positive_svg__k",
    d: "M0 0s19.816 1.244 42.002 3.731c11.419 1.28 27.439-2.158 39.998 0C41.65 54.068 0 0 0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "body_maxi_positive_svg__m",
    d: "M0 0h77.089s-11.985 64.173 5.506 116.559c3.26 60.376 1.101 125.32 1.101 125.32H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "body_maxi_positive_svg__n",
    d: "M0 0h77.089s-11.985 64.173 5.506 116.559c3.26 60.376 1.101 125.32 1.101 125.32H0V0z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "body_maxi_positive_svg__a",
    width: 412,
    height: 602,
    x: 69,
    y: -1
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "body_maxi_positive_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#body_maxi_positive_svg__a"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#body_maxi_positive_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(102.657 28.775)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A16374",
    stroke: "#363A4F",
    strokeWidth: 11,
    d: "M320.63 140.849L309.287 518.27H28.802L17.46 140.85h303.17z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 170.146,
    cy: 154.051,
    fill: "#886653",
    stroke: "#363A4F",
    strokeWidth: 11,
    rx: 154.722,
    ry: 158.451
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 392.197)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "body_maxi_positive_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#body_maxi_positive_svg__c"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#F15165",
    stroke: "#363A50",
    strokeWidth: 22.968,
    xlinkHref: "#body_maxi_positive_svg__c"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBDCCE",
    d: "M10.501 109.873c0-34.704-7.638-106.305-7.638-106.305-1.254-12.507 7.92-22.645 20.498-22.645h299.715c12.576 0 21.667 10.134 20.352 22.65 0 0-7.492 65.838-7.492 97.662 0 40.54 9.91 121.622 9.91 121.622H.591s9.91-75.322 9.91-112.984z",
    mask: "url(#body_maxi_positive_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#363A4F",
    d: "M69.155.149s143.567 160.943 199.999-11.067c59.683-88.794 147.285 32.113 147.285 32.113l-38.096 172.286-412-3.453L-31.07-16.93 69.155.15z",
    mask: "url(#body_maxi_positive_svg__d)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    fillOpacity: 0.1,
    points: "303.699 199.112 309.645 86.198 317.573 196.984",
    mask: "url(#body_maxi_positive_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBDCCE",
    stroke: "#363A50",
    strokeWidth: 10.89,
    d: "M343.113 80.24l-33.693 1.98s-4.954 120.753 5.946 130.743c10.9 9.99 57.476 17.914 57.476 17.914l17.837-37.638-47.566-113zM7.892 80.24l36.4 1.98.113 2.766h0l.172 4.604h0l.104 3.017h0l.186 5.96h0l.115 4.073h0l.112 4.4h0l.105 4.69h0l.065 3.268h0l.06 3.37h0l.053 3.459h0l.045 3.538h0l.037 3.605h0l.026 3.662h0l.016 3.708h0l.004 3.741c-.021 32.542-1.513 67.688-7.637 72.882-4.122 3.497-12.964 6.74-22.719 9.48l-1.68.464c-.563.153-1.128.304-1.694.454l-1.703.444c-.57.146-1.139.29-1.709.433l-1.709.423h0l-1.706.41h0l-1.698.4h0l-1.686.388h0l-1.67.375h0l-1.648.363h0l-1.625.35h0l-2.38.501h0l-2.302.471h0l-1.482.297h0l-2.823.551h0l-2.603.492h0l-2.352.432h0l-2.064.368h0l-2.484.43h0l-2.356.388h0l-19.27-37.638 51.387-113z",
    mask: "url(#body_maxi_positive_svg__d)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    fillOpacity: 0.1,
    points: "312.585 90.436 329.104 94.838 341.218 205.975 353.375 196.071 343.464 87.135 318.135 88.235",
    mask: "url(#body_maxi_positive_svg__d)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#000",
    fillOpacity: 0.1,
    points: "9.862 83.868 31.462 95.972 28.582 203.808 40.102 204.909 45.862 137.692 41.542 85.975",
    mask: "url(#body_maxi_positive_svg__d)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 300.389,
    cy: 216.873,
    fill: "#FBDCCE",
    stroke: "#363A50",
    strokeWidth: 8.91,
    rx: 36.055,
    ry: 36.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 313.31,
    cy: 236.028,
    fill: "#363A50",
    rx: 6.057,
    ry: 6.052
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.501,
    cy: 214.892,
    fill: "#FBDCCE",
    stroke: "#363A50",
    strokeWidth: 8.91,
    rx: 36.055,
    ry: 36.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 34.029,
    cy: 215.08,
    fill: "#000",
    fillOpacity: 0.1,
    rx: 15.418,
    ry: 15.405
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(146.653 317.72)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "body_maxi_positive_svg__f",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#body_maxi_positive_svg__e"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#F9CCB6",
    stroke: "#363A50",
    strokeWidth: 13.86,
    xlinkHref: "#body_maxi_positive_svg__e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8CCB8",
    d: "M10.043 13.708S-1.85 51.346 28.87 71.156c30.72 19.81-5.946 18.819-5.946 18.819l-40.63-33.676-.99-36.648 28.738-5.943z",
    mask: "url(#body_maxi_positive_svg__f)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.989 18.024)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "body_maxi_positive_svg__h",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#body_maxi_positive_svg__g"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#F9CCB6",
    xlinkHref: "#body_maxi_positive_svg__g"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBDCCE",
    stroke: "#363A50",
    strokeWidth: 11,
    d: "M131.917 5.5c34.895.006 66.486 14.151 89.354 37.02 22.873 22.871 37.019 54.47 37.019 89.374h0v63.565c0 35.013-14.179 67.758-37.053 92.416-22.784 24.56-54.217 41.119-88.969 43.839-35.077-2.718-66.668-19.236-89.544-43.754C19.71 263.295 5.5 230.515 5.5 195.46h0v-63.566c0-34.524 13.843-65.815 36.28-88.626C64.25 20.423 95.342 6.082 129.78 5.518h0z",
    mask: "url(#body_maxi_positive_svg__h)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#363A50",
    fillOpacity: 0.1,
    d: "M237.402 126.006s53.054 157.453-90.68 212.008c-143.734 54.554 127.922-24.657 127.922-24.657L374.69 73.92l-128.97 42.375-8.32 9.71z",
    mask: "url(#body_maxi_positive_svg__h)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "body_maxi_positive_svg__j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#body_maxi_positive_svg__i"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A4F",
    strokeWidth: 8.8,
    d: "M146.851-4.221l.64.106C322.216 25.1 293.02 170.067 293.02 170.067s-.423 2.106-1.473 5.739a181.37 181.37 0 00-4.887-2.684c-2.774-1.453-70.728-36.743-138.982-36.612-70.313.135-143.082 36.648-143.082 36.648s-1.708.857-4.752 2.506c-1.067-3.472-1.515-5.484-1.515-5.484s-14.726-66.227 29.408-117.972C49.6 26.573 85.952 4.342 146.15-4.132c.224-.032.448-.063.7-.09z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A16374",
    stroke: "#363A4F",
    strokeWidth: 8.8,
    d: "M146.851-4.221l.64.106C322.216 25.1 293.02 170.067 293.02 170.067s-.423 2.106-1.473 5.739a181.37 181.37 0 00-4.887-2.684c-2.774-1.453-70.728-36.743-138.982-36.612-70.313.135-143.082 36.648-143.082 36.648s-1.708.857-4.752 2.506c-1.067-3.472-1.515-5.484-1.515-5.484s-14.726-66.227 29.408-117.972C49.6 26.573 85.952 4.342 146.15-4.132c.224-.032.448-.063.7-.09z",
    mask: "url(#body_maxi_positive_svg__j)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#363A50",
    fillOpacity: 0.2,
    d: "M165.403-9.775s102.003 69.85 102.003 99.2c0 29.35-218.692-44.595-271.347 82.107-52.654 126.702 43.878 44.437 43.878 44.437l320.258-21.385 20.148-136.69L253.15-5.83l-87.747-3.945z",
    mask: "url(#body_maxi_positive_svg__j)"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 7,
    d: "M271.39 173.513c-4.717-12.957-23.124-18.153-41.114-11.606M70.72 170.542c4.715-12.958 23.122-18.154 41.112-11.606"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 4.657,
    d: "M166.936 236.14s-4.476 20.461.319 25.092c4.795 4.63 17.052-.284 17.052-.284"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 244.272,
    cy: 185.806,
    fill: "#FFF",
    rx: 19.324,
    ry: 14
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.61,
    cy: 185.806,
    fill: "#FFF",
    rx: 19.324,
    ry: 14
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 4.851,
    d: "M23.478 211.172c5.91-3.551 13.578-1.64 17.128 4.267h0c3.55 5.907 1.636 13.575-4.274 17.126M302.444 203.426c5.203-4.523 13.087-3.974 17.608 1.228h0c4.522 5.201 3.97 13.085-1.234 17.608"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M166.74 235.072s-2.073 23.06 19.87 27.462l-16.6 2.2-4.405-6.601 1.136-23.06z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 243.806,
    cy: 185.678,
    fill: "#363A50",
    rx: 10.462,
    ry: 10.453
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.806,
    cy: 185.678,
    fill: "#363A50",
    rx: 10.462,
    ry: 10.453
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#363A50",
    points: "134.713 140.914 143.988 48.587 149.916 140.819"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#363A50",
    points: "224.658 145.248 231.377 80.327 235.671 145.182"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#363A50",
    points: "80.392 154.051 87.111 89.13 91.405 153.985"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(129.343 281.225)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "body_maxi_positive_svg__l",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#body_maxi_positive_svg__k"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#E68794",
    xlinkHref: "#body_maxi_positive_svg__k"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M0-.424S24.2 13.27 41.75 13.964C59.3 14.657 84 2.182 84 2.182L18.661-7 0-.424z",
    mask: "url(#body_maxi_positive_svg__l)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 53,
    x: 147.846,
    y: 357.225,
    fill: "#FBDCCE"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M150.777 352.73s54.01 7.702 54.01 20.906l3.303-27.509-57.313 6.603z"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 8,
    d: "M420 267c3.715 0 7.091 1.757 9.598 4.623 2.71 3.1 4.402 7.499 4.402 12.377 0 9.389-6.268 17-14 17s-14-7.611-14-17c0-1.852.244-3.635.695-5.305"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#363A50",
    strokeLinecap: "round",
    strokeWidth: 5,
    d: "M283 282c1.857 0 3.546.878 4.799 2.312 1.355 1.55 2.201 3.749 2.201 6.188 0 4.694-3.134 8.5-7 8.5-2.828 0-5.265-2.037-6.37-4.969a9.54 9.54 0 01-.193-.567"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    transform: "translate(334.367 421.12)",
    xlinkHref: "#body_maxi_positive_svg__m"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7084B1",
    stroke: "#363A4F",
    strokeWidth: 7.1,
    d: "M333.367 415h77.089s-11.985 66.062 5.506 119.99c3.26 62.154 1.101 129.01 1.101 129.01h-83.696V415z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    transform: "matrix(-1 0 0 1 225.342 411.12)",
    xlinkHref: "#body_maxi_positive_svg__n"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#79BEAA",
    stroke: "#363A4F",
    strokeWidth: 6.1,
    d: "M228.74 412.12h-77.09s11.985 64.173-5.506 116.56c-3.26 60.376-1.101 125.32-1.101 125.32h83.696V412.12z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodymaxipositive);
export default __webpack_public_path__ + "static/media/body.maxi.positive.72a3fc68.svg";
export { ForwardRef as ReactComponent };